import styles from "../Editor.module.css";
import InputControl from "../../InputControl/InputControl";

const PorBody = (props) => {
    const sections = props.sections;
    const pors = ["POR1","POR2","POR3","POR4","POR5"];
  return (
    <div className={styles.detail}>
      <div className={styles.column}>
        <label>List your PORs</label>
        {pors.map((por,index)=>(
          <InputControl
            placeholder={por}
            value={props.information[sections.por].points ? props.information[sections.por].points[index] : ""}
            // value={values.points ? values.points[index] : ""}
            onChange={(event) => 
              // handlePointUpdate(event.target.value, index)
              props.setInformation((prev) => ({ ...prev, 
                [sections.por]: {...prev[sections.por],
                    points: prev[sections.por].points.map((point, pointIndex) =>
                      pointIndex === index? event.target.value : point
                    )
                }
              }))
            }
          />
        ))}
      </div>
    </div>
  )
}

export default PorBody